// extracted by mini-css-extract-plugin
export default {"button":"OutlineButton_button__U4f+e","alwaysGlow":"OutlineButton_alwaysGlow__Ixygz","animatedBorder":"OutlineButton_animatedBorder__aHSw2"};